import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import { ThemeContext } from "../../context/ThemeProvider";
import Body from "../../ui/Body";

import QsOrder from "./QsOrder";

export default function Qs_order() {

  // theme context


  let navigate = useNavigate();


  return (
    <>
      {/* navigation section */}
      <section>
        <Sidebar />
        <Nabvar />
      </section>

      {/* body */}
      <Body>
        <QsOrder />
      </Body>
    </>
  );
}
